// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"291ec5ed","455":"47b793a9","977":"45786ea9"}[chunkId] + ".chunk.js";
};